export default {
  // general layouts: /
  'Aguarde ...': 'Aguarde ...',
  Aguarde: 'Aguarde',
  Continuar: 'Continuar',
  'ATENÇÃO:': 'ATENÇÃO:',
  'Voltar para início': 'Voltar para início',
  Cancelar: 'Cancelar',
  'Confirmar dados': 'Confirmar dados',
  'Salvar novo endereço': 'Salvar novo endereço',
  'Endereço atualizado com sucesso!': 'Endereço atualizado com sucesso!',
  Ok: 'Ok',

  // page: /error-campaign
  'Ocorreu um erro': 'Ocorreu um erro',
  'A campanha não foi encontrada ou não está mais ativa': 'A campanha não foi encontrada ou não está mais ativa',

  // page: /not-eligible
  'Ops!': 'Ops!',
  'Loja não cadastrada para esta campanha': 'Loja não cadastrada para esta campanha',

  // page: /login
  'Bem-vindo(a) à plataforma': 'Bem-vindo(a) à plataforma',
  'Ação de Fluxo GB': 'Ação de Fluxo GB',
  'Para ativar sua loja para esta ação, precisamos que': 'Para ativar sua loja para esta ação, precisamos que',
  'você faça o login e cadastre algumas informações': 'você faça o login e cadastre algumas informações',
  'Ao entrar, afirmo estar de acordo com a {privacidade}.': 'Ao entrar, afirmo estar de acordo com a {privacidade}.',
  Acessar: 'Acessar',
  'cancelar tentativa de acesso': 'cancelar tentativa de acesso',
  Login: 'Login',
  'Digite seu login': 'Digite seu login',
  Senha: 'Senha',
  'Digite sua senha': 'Digite sua senha',
  CPF: 'CPF',
  'Digite o CPF - apenas números': 'Digite o CPF - apenas números',
  Entrar: 'Entrar',
  'Login pela extranet': 'Login pela extranet',
  'Tente acessar novamente utilizando os mesmos dados da Extranet:': 'Tente acessar novamente utilizando os mesmos dados da Extranet:',

  // page: /hub
  'Você tem acesso a mais de uma loja.': 'Você tem acesso a mais de uma loja.',
  'Escolha qual você quer administrar agora:': 'Escolha qual você quer administrar agora:',
  'Telefone: {phone}': 'Telefone: {phone}',
  'Carregando campanhas': 'Carregando campanhas',
  'Nenhuma campanha ativa para essa loja': 'Nenhuma campanha ativa para essa loja',
  'Esta é a campanha disponível para a loja:': 'Esta é a campanha disponível para a loja:',
  'Há mais de uma campanha para essa loja.': 'Há mais de uma campanha para essa loja.',
  'Escolha qual administrar:': 'Escolha qual administrar:',
  'habilitação pendente': 'habilitação pendente',

  // page: /checkin/stepper
  'dados da loja': 'dados da loja',
  brindes: 'brindes',
  datas: 'datas',
  horários: 'horários',

  // page: /checkin/step-1
  'Preencha os campos e confira seus dados.': 'Preencha os campos e confira seus dados.',
  'Nome como a loja é conhecida:': 'Nome como a loja é conhecida:',
  'ex: Boticário Shopping Iguatemi': 'ex: Boticário Shopping Iguatemi',
  'Telefone:': 'Telefone:',
  'Endereço:': 'Endereço:',
  'editar endereço': 'editar endereço',

  // page: /checkin/step-2
  'Confira e informe quantos brindes ”{prm}” sua loja possui para a Ação de Fluxo.': 'Confira e informe quantos brindes ”{prm}” sua loja possui para a Ação de Fluxo.',
  'Quantidade de brindes:': 'Quantidade de brindes:',
  'Quantidade de brindes destinados a retirada em loja:': 'Quantidade de brindes destinados a <strong>retirada em loja</strong>:',
  'Quantidade de brindes destinados a retirada via Omnichat:': 'Quantidade de brindes destinados a <strong>retirada via Omnichat</strong>.',
  'se não possuir nenhum, preencha com ”0”': 'se não possuir nenhum, preencha com ”0”',
  'Indique o número de brindes que a loja possui no estoque físico agora. A quantidade é auditada pela SECAP (Secretaria de políticas públicas, planejamento, energia e loteria do ministério da ecônomia).': 'Indique o número de brindes que a loja possui no estoque físico agora. A quantidade é auditada pela SECAP (Secretaria de políticas públicas, planejamento, energia e loteria do ministério da ecônomia).',
  'A loja deveria ter {numeroBrindes} para a ação de fluxo.': 'A loja deveria ter {numeroBrindes} para a ação de fluxo.',
  'A loja deveria ter {numeroBrindes} para a retirada em loja e mais {numeroBrindesWhats} para a entrega via Omnichat.': 'A loja deveria ter {numeroBrindes} para a retirada em loja e mais {numeroBrindesWhats} para a entrega via Omnichat.',
  'Nos informe porque este número está diferente.': 'Nos informe porque este número está diferente.',
  'Recebi uma quantidade diferente de brindes.': 'Recebi uma quantidade diferente de brindes.',
  'Já distribuí alguns brindes para a equipe.': 'Já distribuí alguns brindes para a equipe.',
  'Outro motivo.': 'Outro motivo.',
  'Descreva o motivo': 'Descreva o motivo',
  'Descreva aqui o motivo dessa diferença': 'Descreva aqui o motivo dessa diferença',
  'ATENÇÃO!': 'ATENÇÃO!',
  'Essa campanha terá a LOJA DIGITAL como opção de resgate e como ela possui uma mecânica diferente (a entrega do brinde deve estar atrelada a uma compra), será preciso ter uma quantidade específica de estoque para ela. Então, a divisão será essa:': 'Essa campanha terá a LOJA DIGITAL como opção de resgate e como ela possui uma mecânica diferente (a entrega do brinde deve estar atrelada a uma compra), será preciso ter uma quantidade específica de estoque para ela. Então, a divisão será essa:',
  'dos {prmsQty} brindes recebidos': 'dos {prmsQty} brindes recebidos',
  'são para entregar em loja física': 'são para entregar em loja física',
  'são para entregar em loja digital': 'são para entregar em loja digital',
  'Caso tenha alguma dúvida, entre em contato com o CSF (Centro de Serviços ao Franqueado) - (41) 3375-1515.': 'Caso tenha alguma dúvida, entre em contato com o CSF (Centro de Serviços ao Franqueado) - (41) 3375-1515.',

  // page: /checkin/step-2-error
  'Infelizmente, apenas as lojas que receberam os kits promocionais poderão participar dessa campanha :(': 'Infelizmente, apenas as lojas que receberam os kits promocionais poderão participar dessa campanha :(',
  'Entre em contato com o CSF (Centro de Serviços ao Franqueado) para saber o que você deve fazer em relação à campanha - {fone}': 'Entre em contato com o CSF (Centro de Serviços ao Franqueado) para saber o que você deve fazer em relação à campanha - {fone}',
  'voltar e corrigir dados': 'voltar e corrigir dados',
  'sair da campanha': 'sair da campanha',

  // page: /checkin/step-3
  Sim: 'Sim',
  Não: 'Não',
  'A sua loja abre aos sábados?': 'A sua loja abre aos sábados?',
  'E aos domigos?': 'E aos domigos?',
  'Indique em que dias a loja fará a entrega dos brindes.': 'Indique em que dias a loja fará a entrega dos brindes.',
  'Fique atento(a) à abertura da loja aos feriados.': 'Fique atento(a) à abertura da loja aos feriados.',
  'Você já desmarcou a quantidade máxima de dias possíveis para esta ação': 'Você já desmarcou a quantidade máxima de dias possíveis para esta ação',
  'Esse dia não pode ser alterado pois já existem reservas nele.': 'Esse dia não pode ser alterado pois já existem reservas nele.',
  'dias em que a loja fará a entrega dos brindes': 'dias em que a loja fará a entrega dos brindes',
  'Deixe marcado com a bolinha': 'Deixe marcado com a bolinha',
  'os dias em que a loja pode entregar brindes.': 'os dias em que a loja pode entregar brindes.',
  verde: 'verde',
  roxa: 'roxa',
  azul: 'azul',
  'Nos dias em que não pode, deixe sem bolinha': 'Nos dias em que não pode, deixe sem bolinha',
  '.': '.',

  // page: /checkin/step-4
  'Indique os horários em que você deseja que os clientes façam o resgate dos brindes.': 'Indique os horários em que você deseja que os clientes façam o resgate dos brindes.',
  'O cliente verá os horários escolhidos como sugestões para comparecer à loja, mas poderá vir fora do horário agendado.': 'O cliente verá os horários escolhidos como sugestões para comparecer à loja, mas poderá vir fora do horário agendado.',
  'Adicionar horário': 'Adicionar horário',
  Finalizar: 'Finalizar',

  // component: /header
  'Olá, {name}! {cpf}': 'Olá, {name}! {cpf}',

  // component: /dashboard/header
  Resgate: 'Resgate',
  'Clientes do dia': 'Clientes do dia',
  'Status da campanha': 'Status da campanha',
  Ajustes: 'Ajustes',
  Chamados: 'Chamados',
  'Dados da Loja': 'Dados da loja',

  // page: /dashboard
  'Dashboard da Campanha': 'Dashboard da Campanha',
  'PRONTO!': 'PRONTO!',
  'Sua loja está habilitada a distribuir as {quantidade} unidades de {prm}, para a campanha {campanha}.': 'Sua loja está habilitada a distribuir as {quantidade} unidades de {prm}, para a campanha {campanha}.',
  'ir para página da campanha': 'ir para página da campanha',
  'Consultar CPF para o resgate do {prm}': 'Consultar CPF para o resgate do {prm}',
  'Número de CPF inválido': 'Número de CPF inválido',
  'CPF ou cupom não encontrado!': 'CPF ou cupom não encontrado!',
  'Não entregue o {prm} ao cliente e peça para que tente se cadastrar na campanha novamente.': 'Não entregue o {prm} ao cliente e peça para que tente se cadastrar na campanha novamente.',
  'O(a) cliente está na loja errada!': 'O(a) cliente está na loja errada!',
  'Este CPF ou Cupom já foi utilizado!': 'Este CPF ou Cupom já foi utilizado!',
  'Resgate já efetuado na loja {store}, no dia {date}': 'Resgate já efetuado na loja {store}, no dia {date}',
  'Direcione o(a) cliente a loja {loja}': 'Direcione o(a) cliente a loja {loja}',
  'Não entregue o {prm} ao cliente.': 'Não entregue o {prm} ao cliente.',
  'Preencha os dados do consumidor:': 'Preencha os dados do consumidor:',
  'Cupom inválido para uso em Loja!': 'Cupom inválido para uso em Loja!',
  'Não entregue o {prm} ao cliente. E peça para que ele verifique se o cupom foi gerado para resgate no site ou com uma revendedora.': 'Não entregue o {prm} ao cliente. E peça para que ele verifique se o cupom foi gerado para resgate no site ou com uma revendedora.',
  'Cupom expirado!': 'Cupom expirado!',
  'Não entregue o {prm} ao cliente e o oriente a refazer o cadastro na campanha.': 'Não entregue o {prm} ao cliente e o oriente a refazer o cadastro na campanha.',
  'enviar link por e-mail': 'enviar link por e-mail',
  'Antes de fazer o resgate, confira se os dados estão corretos': 'Antes de fazer o resgate, confira se os dados estão corretos',
  'Não entregue o {prm} se um deles estiver errado.': 'Não entregue o {prm} se um deles estiver errado.',
  'Código:': 'Código:',
  'não resgatar': 'não resgatar',
  'confirmar dados e resgatar': 'confirmar dados e resgatar',
  'CPF registrado com sucesso!': 'CPF registrado com sucesso!',
  'Entregue o {prm} ao cliente.': 'Entregue o {prm} ao cliente.',
  Copiar: 'Copiar',
  Copiado: 'Copiado',
  'STATUS DE SOLICITAÇÕES DE ESTOQUE': 'STATUS DE SOLICITAÇÕES DE ESTOQUE',
  'Estoque atual da loja': 'Estoque atual da loja',
  'Loja ainda não fez check-in': 'Loja ainda não fez check-in',
  'Não é possível fazer ajustes nessa campanha com retirada via Omnichat, pois o consumidor não tem acesso à essas informações. Caso esteja tendo problemas com a retirada na loja, você precisa trocar de campanha e fazer os ajustes por lá.': 'Não é possível fazer ajustes nessa campanha com retirada via Omnichat, pois o consumidor não tem acesso à essas informações. Caso esteja tendo problemas com a retirada na loja, você precisa trocar de campanha e fazer os ajustes por lá.',
  'Não houve compra': 'Não houve compra',
  'Houve compra': 'Houve compra',
  'Não entregue o brinde, ao menos que seja realizada uma compra.': 'Não entregue o brinde, ao menos que seja realizada uma compra.',
  'Este CPF está atrelado a uma compra via LOJA DIGITAL!': 'Este CPF está atrelado a uma compra via LOJA DIGITAL!',
  Voltar: 'Voltar',
  'Lembre-se de enviar o {prm} junto com o pedido realizado via loja digital.': 'Lembre-se de enviar o {prm} junto com o pedido realizado via loja digital.',
  'Registro efetuado com sucesso!': 'Registro efetuado com sucesso!',
  'O estoque de {prm} para a loja digital já acabou!': 'O estoque de {prm} para a loja digital já acabou!',

  // page: /dashboard/status
  'RESGATES EFETUADOS': 'RESGATES EFETUADOS',
  'Valores de resgates são atualizados em tempo real. E atenção: faça a baixa do brinde corretamente na plataforma! Evite perda de pontos no IAF!': 'Valores de resgates são atualizados em tempo real. E atenção: faça a baixa do brinde corretamente na plataforma! Evite perda de pontos no IAF!',
  CONVERSÕES: 'CONVERSÕES',
  '(apenas de vendas com o código aplicado no PDV e Mobshop)': '(apenas de vendas com o código aplicado no PDV e Mobshop)',
  'Os valores são referentes aos resgates e às vendas realizadas desde o início da campanha até o dia anterior. Atenção: apenas as vendas com código aplicado no PDV e Mobshop serão contabilizadas como conversão. Evite perda de pontos no IAF!': 'Os valores são referentes aos resgates e às vendas realizadas desde o início da campanha até o dia anterior. Atenção: apenas as vendas com código aplicado no PDV e Mobshop serão contabilizadas como conversão. Evite perda de pontos no IAF!',
  'Na loja física': 'Na loja física',
  'Na loja digital': 'Na loja digital',
  'RESULTADO DA CAMPANHA': 'RESULTADO DA CAMPANHA',
  'BRINDES RESTANTES': 'BRINDES RESTANTES',
  'Restam {totalRpm} brindes': 'Restam {totalRpm} brindes',
  '* Todos os resgates da loja digital são obrigatoriamente acompanhados de conversão a partir de {redeemConditionMessage}': '* Todos os resgates da loja digital são obrigatoriamente acompanhados de conversão a partir de {redeemConditionMessage}',
  '{current} de {total} possíveis ({totalPercentage}%)': '{current} de {total} possíveis ({totalPercentage}%)',
  'melhor que {totalPercentage}% das lojas': 'melhor que {totalPercentage}% das lojas',
  '{totalRpm} dos quais {scheduledRpm} já estão reservados': '{totalRpm} dos quais {scheduledRpm} já estão reservados',
  'cupons restantes': 'CUPONS RESTANTES',
  'Resultado da sua loja na campanha até o momento': 'RESULTADO DA SUA LOJA NA CAMPANHA ATÉ O MOMENTO',
  'Muito bom! Continue Assim!': 'Muito bom! Continue Assim!',
  'Parabéns! Todos os cupons ja foram utilizados.': 'Parabéns! Todos os cupons ja foram utilizados.',
  'Boleto médio': 'BOLETO MÉDIO',
  Receita: 'RECEITA',
  'Aguarde, carregando dados...': 'Aguarde, carregando dados...',
  'Seus resgates não estão sendo registrados corretamente.': 'Seus resgates não estão sendo registrados corretamente.',

  // page: /dashboard/consumer
  'Veja todas as reservas de brindes para o dia de hoje - {dia}': 'Veja todas as reservas de brindes para o dia de hoje - {dia}',
  'Nenhuma reserva encontrada nessa data': 'Nenhuma reserva encontrada nessa data',
  'Retirados: ': 'Retirados: ',
  '{retirados} de um total de {total}': '{retirados} de um total de {total}',
  Imprimir: 'Imprimir',
  'A taxa de expiração dos vouchers é de aproximadamente 50%.': 'A taxa de expiração dos vouchers é de aproximadamente 50%.',
  'Entenda aqui': 'Entenda aqui',
  RescueVoucherTitle: 'Historicamente, com dados das outras campanhas de ação de fluxo, sabemos que a metade dos consumidores não irá até a loja e 50% destes vouchers serão expirados.',
  RescueVoucherDescription: 'Atenção: no calendário da campanha é muito importante não desabilitar um dia da semana de forma recorrente para a entregar de brindes, pois a plataforma redistribuirá automaticamente o volume nos dias restantes em que a loja optou por entregar brindes. Por exemplo, se a sua loja faria entrega de brindes durante 5 dias da semana, e 1 desses dias for desabilitado de maneira recorrente para entrega de brindes, o volume de vouchers será redistribuído nos outros 4 dias restantes, aumentando desta maneira a quantidade de brindes por dia.',
  'Não retirado': 'Não retirado',
  Expirado: 'Expirado',
  Retirado: 'Retirado',
  'Horário escolhido:': 'Horário escolhido:',
  das: 'das',
  as: 'às',
  e: 'e',
  'não há nenhuma reserva para este dia': 'não há nenhuma reserva para este dia',

  // PAGE: /dashboard/data
  Editar: 'Editar',
  Salvar: 'Salvar',
  'Dias em que a loja fará a entrega dos brindes': 'Dias em que a loja fará a entrega dos brindes',
  'Deixe marcado com a bolinha verde os dias em que a loja pode entregar brindes. Nos dias em que não pode, deixe sem bolinha verde.': 'Deixe marcado com a bolinha <strong>verde</strong> os dias em que a loja pode entregar brindes. Nos dias em que não pode, deixe sem bolinha <strong>verde</strong>.',
  'Caso queira alterar os dias, entre em contato com o CSF (Centro de Serviços ao Franqueado) - {fone}.': 'Caso queira alterar os dias, entre em contato com o CSF (Centro de Serviços ao Franqueado) - {fone}.',
  'Não é possível alterar dia que já possuem reserva de consumidores': 'Não é possível alterar dia que já possuem reserva de consumidores',
  'As alterações de horário refletirão apenas nos cadastros futuros dos consumidores': 'As alterações de horário refletirão apenas nos cadastros futuros dos consumidores',
  'Horários em que a loja fará a entrega dos brindes': 'Horários em que a loja fará a entrega dos brindes',
  'de:': 'de:',
  'até:': 'até:',
  'Caso queira alterar os horários, entre em contato com o CSF (Centro de Serviços ao Franqueado) - {fone}.': 'Caso queira alterar os horários, entre em contato com o CSF (Centro de Serviços ao Franqueado) - {fone}.',
  'Editar dias': 'Editar dias',
  'Salvar Edição': 'Salvar Edição',
  'Editar horários': 'Editar horários',
  // page: /reserves
  'Acompanhe aqui a sua agenda de reservas': 'Acompanhe aqui a sua agenda de reservas',
  'Semana {numero}': 'Semana {numero}',
  'Olá {consumidor}, me chamo {revendedora}, sou revendedor(a) O Boticário e recebi a sua reserva de um {prm}, gostaria de retirar seu brinde em qual data?': 'Olá {consumidor}, me chamo {revendedora}, sou revendedor(a) O Boticário e recebi a sua reserva de um {prm}, gostaria de retirar seu brinde em qual data?',
  '{data_inicial} até {data_final}': '{data_inicial} até {data_final}',
  RESGATADO: 'RESGATADO',
  EXPIRADO: 'EXPIRADO',
  RESERVADO: 'RESERVADO',
  'Não houveram reservas para esse período': 'Não houveram reservas para esse período',
  Ligar: 'Ligar',
  Whatsapp: 'Whatsapp',
  Fechar: 'Fechar',

  // pages: /redeem
  'Confira se o CPF está correto': 'Confira se o CPF está correto',
  'Confira se todos os números do Voucher foram digitados': 'Confira se todos os números do Voucher foram digitados',
  'Digite o CPF do consumidor:': 'Digite o CPF do consumidor:',
  'Digite o código do cupom:': 'Digite o código do cupom:',
  'Registre aqui o resgate da amostra antes de entrega-la ao consumidor': 'Registre aqui o resgate da amostra antes de entrega-la ao consumidor',
  'Como deseja informar o resgate da amostra?': 'Como deseja informar o resgate da amostra?',
  'CPF do Consumidor': 'CPF do Consumidor',
  'Cupom do Consumidor': 'Cupom do Consumidor',
  Verificar: 'Verificar',
  'Para esta promoção, utilize a Plataforma de Ação de Fluxo apenas para consulta. Por favor, utilize o PDV para efetivar o resgate.': 'Para esta promoção, utilize a Plataforma de Ação de Fluxo apenas para consulta. Por favor, utilize o PDV para efetivar o resgate.',
  'Confira os dados do(a) cliente.': 'Confira os dados do(a) cliente.',
  'Confira as campanhas do(a) cliente.': 'Confira as campanhas do(a) cliente.',
  'O cashback dessa campanha já foi utilizado!': 'O cashback dessa campanha já foi utilizado!',
  'Este CPF já foi utilizado!': 'Este CPF já foi utilizado!',
  'data de expiração do cupom:': 'data de expiração do cupom: ',
  'valor do crédito de volta:': 'valor do crédito de volta: ',
  'CPF:': 'CPF: ',
  'Valor utilizado:': 'Valor utilizado: ',
  'Valor total do crédito:': 'Valor total do crédito:',
  'Data do resgate:': 'Data do resgate: ',
  'Data de expiração do cupom:': 'Data de expiração do cupom:',
  'Loja do resgate:': 'Loja do resgate: ',
  'Endereço da loja:': 'Endereço da loja: ',
  '(Possui saldo ativo para as próximas compras)': '(Possui saldo ativo para as próximas compras)',
  'Aproveite e informe ao cliente que ele tem saldo para o próximo cashback e o resgate começa em breve.': 'Aproveite e informe ao cliente que ele tem saldo para o próximo cashback e o resgate começa em breve.'
}
